import React, { type ComponentPropsWithoutRef } from "react";
import {
  pillarTableColumnArrayValue,
  type PathToArray,
} from "shared/components/pillar-table/columns/array/PillarTableColumnArray";
import type { PillarTableBaseColumnCellValuePathProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";

export const PillarTableColumnArrayCount = <T,>({
  cellValuePath,
}: Omit<PillarTableBaseColumnCellValuePathProps<T>, "cellValuePath"> & {
  cellValuePath: PathToArray<T>;
} & ComponentPropsWithoutRef<"div">) => {
  const rowContext = usePillarTableRowContext();
  const arrayValue = pillarTableColumnArrayValue({
    rowContext,
    cellValuePath,
  });
  return <>{Array.isArray(arrayValue) ? arrayValue.length : 0}</>;
};
